/**
 * `${SCOPE}_${ACTION}`, byte-identical to `@adornis/abac`'s own
 * `defaultPermissionResolver`.
 *
 * Copied rather than imported, and that is the entire point. Importing anything
 * from `defineScopePolicy.js` — even this one-line helper — statically pulls in
 * `server/role-resolver.js` and `policies/Roles.js`, and the latter registers
 * `assignRolesToUser`, `reassignRole`, `removeRoleGrant` and the rest as GraphQL
 * operations at module scope. Those would end up in the schema backed by resolvers
 * that throw, because `initRoleManagement` is never called — reachable, broken,
 * and still carrying the two lockout paths this work exists to remove. One duplicated template literal keeps *our* module graph clear of it.
 *
 * It does not make the role graph absent overall: `@adornis/entity-relationship-management`
 * imports `Roles.js` itself, from both `api/index.js` and `init.js`, so those
 * operations are still registered. They are inert — every one of their resolvers
 * calls `getRoleABAC()`/`getRoleDatalayer()`, which throw because
 * `initRoleManagement` is never called — but they are in the schema.
 *
 * It lives alone in this file, with no imports of its own, because both
 * `grants.ts` and `defineSaraaScopePolicy.ts` need it and they already import each
 * other. Hanging it off either one puts it in the cycle, and `grants.ts` builds
 * its table at module scope — so it would call this while still in the temporal
 * dead zone and fail at import time with `permissionFor is not a function`.
 */
export const permissionFor = (scope: string, action: string): string =>
  `${scope.toUpperCase()}_${action.toUpperCase()}`;
